exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".first-circle[data-v-179b5638] {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.last-circle[data-v-179b5638] {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.circle[data-v-179b5638] {\n  width: 24px;\n  height: 16px;\n}\n.bg-color-light-red[data-v-179b5638] {\n  background-color: indianred;\n}", ""]);

// exports
